import YaCounter from "../analytics/ym";
import GoogleAnalytics from "../analytics/ga";

window.VegasCatalog.Cart = {
	add: function (id, cnt, params, callback) {
		params = params || [];

		params.push({name: "_token", value: App.csrf});
		params.push({name: "id", value: id});
		params.push({name: "cnt", value: cnt || 1});

		this.addRequest(params, callback);
	},

	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
			VegasCatalog.popup('Добавлено в корзину');

			new YaCounter().goal('add-to-cart');
		});
	},

	changeCnt: function (id, cnt, appendParams, callback) {
		let params = appendParams || {};
		params.id = id;
		params.cnt = cnt;
		params = VegasCatalog.Cart.formData(params);

		$.post('/cart/change_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
		});
	},

	remove: function (id, callback) {
		let params = {};
		params.id = id.id || null;
		params.pivot_id = id.pivot_id || null;
		params._token = App.csrf;
		params = VegasCatalog.Cart.formData(params);

		this.removeRequest(params, callback);
	},

	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
			VegasCatalog.popup('Убрано из корзины');
		});
	},

	total: function (data) {
		let sumsAll = data.sums_all || data.sums || {};

		if (typeof data.products_count !== 'undefined') {
			$('[data-cart][data-counter=products]').attr('data-cnt', data.products_count);
		}

		if (typeof sumsAll.sum_products !== 'undefined') {
			let $elem = $('[data-cart][data-counter="products-sum"]');
			$elem.attr('data-sum', sumsAll.sum_products);
			if ($elem.data('with-value')) {
				$elem.html(output_roubles(sumsAll.sum_products));
			}
		}

		this.totalCartForm(data);
		this.totalCartProducts(data);
		this.toggleEmpty(data);
	},

	totalCartForm: function (data) {
		let $form = $('#form-cart');

		if ($form.length) {
			// cart sum
			let $sCart = $form.find('[data-sum="total"]');
			$sCart.find('[data-sum-value]').text(output_roubles(data.sums.sum));
		}
	},

	totalCartProducts: function (data) {
		let $cartProducts = $('.catalog-cart--products');
		if ($cartProducts.length && typeof data.products_totals !== 'undefined') {
			for(let i in data.products_totals) {
				let p = data.products_totals[i];

				$cartProducts.find('[data-product-cart-item][data-pivot_id="'+p.pivot_id+'"]')
					.find('.price-total')
					.text(output_roubles(p.price_total));
			}
		}
	},

	toggleEmpty: function (data) {
		let $wrapper = $('.catalog-cart--wrapper');
		if (!$wrapper.length) {
			return;
		}

		let hasProducts = Number(data.products_count || 0) > 0;
		$wrapper.find('.catalog-cart--products').toggleClass('d-none', !hasProducts);
		$wrapper.find('.catalog-cart--total').toggleClass('d-none', !hasProducts);
		$wrapper.find('[data-cart-empty]').toggleClass('d-none', hasProducts);
	},

	updateTotalAll: function () {
		$.get('/cart/get_totals', VegasCatalog.Cart.formData(), function (data) {
			VegasCatalog.Cart.total(data);
		});
	},

	formData: function (appendParams) {
		appendParams = appendParams || {};
		let resultParams = $('#form-cart').serializeArray();
		if (!resultParams.length) {
			resultParams = $('#form-cart-order').serializeArray();
		}

		if (!resultParams.length) {
			resultParams.push({name: '_token', value: App.csrf});
		}

		for (let name in appendParams) {
			resultParams.push({name: name, value: appendParams[name]});
		}

		return resultParams;
	},
};

let $document = $(document),
	$formCart = $("#form-cart")
;

/** Open Cart **/
$document.on('click', '[data-toggle="vg-sidebar"]', function () {
	let $self = $(this),
		route = $self.attr('data-route'),
		$cart_content = $('#catalog-cart--content');

	if ($cart_content.length) {
		setTimeout(function () {
			$.get(route, {}, function (data) {
				$cart_content.html(data);
			});
		}, 800)
	}

	return true;
});

/** PRODUCT LIST **/
$document.on('click', '[data-product-item] [data-cart][data-action=add]', function () {
	let $product = $(this).closest('[data-product-item]'),
		$btn = $(this),
		id = $product.data('id');

	$product.addClass('in-cart');

	VegasCatalog.Cart.add(id);

	return false;
});

$document.on('click', '[data-product-item] [data-qty=trash]', function () {
	let $product = $(this).closest('[data-product-item]');
	let id = $product.data('id');

	$product.removeClass('in-cart');

	VegasCatalog.Cart.remove({id: id});

	return false;
});

$document.on('change-counter', '[data-product-item] [data-cart="qty"]', function (e, data) {
	let $product = $(this).closest('[data-product-item]');
	let id = $product.data('id');

	VegasCatalog.Cart.changeCnt(id, data.cnt);
	$product.find('[data-total-price]').html(output_roubles(data.price_total));

	return false;
});

/** PRODUCT SHOW **/
$document.on('click', '[data-product] [data-cart][data-action=add]', function () {
	let $product = $(this).closest('[data-product]');
	let id = $product.data('id');

	$product.addClass('in-cart');

	VegasCatalog.Cart.add(
		id,
		1,
		$product.find('form.variants').serializeArray(),
		function (data) {
			if (data.error) {
				VegasCatalog.popup("Не получилось добавить товар в корзину", {}, 'error');
			} else {
				$(`[data-product-item][data-id=${id}]`).addClass('in-cart');
				$('#modal-prd').modal('hide');
			}
		}
	);

	return false;
});

$document.on('change-counter', '[data-product] [data-cart="qty"]', function (e, data) {
	let $product = $(this).closest('[data-product]');
	let id = $product.data('id');

	VegasCatalog.Cart.changeCnt(id, data.cnt);

	return false;
});
$document.on('click', '[data-product] [data-qty=trash]', function () {
	let $product = $(this).closest('[data-product]');
	let id = $product.data('id');

	$product.removeClass('in-cart');
	VegasCatalog.Cart.remove({id: id});

	return false;
});

/** PRODUCT CART ITEM */
$document.on('change-counter', '[data-product-cart-item] [data-cart="qty"]', function (e, data) {
	let $product = $(this).closest('[data-product-cart-item]');
	let pivot_id = $product.data('pivot_id');

	let params = {pivot_id: pivot_id, get_products_totals: true};
	VegasCatalog.Cart.changeCnt(0, data.cnt, params);

	return false;
});
$document.on('click', '[data-product-cart-item] [data-cart][data-action="del"]', function () {
	let $product = $(this).closest('[data-product-cart-item]');
	let pivot_id = $product.data('pivot_id');
	let id = $product.data('id');

	$product.remove();

	$(`[data-product-item][data-id=${id}]`).removeClass('in-cart');

	VegasCatalog.Cart.remove({pivot_id: pivot_id});

	return false;
});
